export enum FreightTrackingInfoExternalIdType {
  FREIGHT_SHIPMENT = "FREIGHT_SHIPMENT",
  INBOUND_SHIPMENT = "INBOUND_SHIPMENT",
}
